import React, { useEffect, useState } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { delay } from 'utils/delay';

type AriaAlertProps = {
  children?: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  root: {
    position: 'absolute',
    width: 0,
    height: 0,
    left: -1000,
    top: -1000
  }
}));

export const AriaAlert: React.FC<AriaAlertProps> = ({
  children
}: AriaAlertProps): JSX.Element => {
  const [show, setShow] = useState(true);

  const classes = useStyles();

  useEffect(() => {
    const showHide = async () => {
      await delay(1000);
      setShow(false);
    };
    showHide(); // auto hide
  }, []);

  if (!show) return <></>;

  return (
    <div role="alert" data-testid="aria-alert" className={classes.root}>
      {children}
    </div>
  );
};
